/* 

Implementing GCLID tracking so that user's gclid is sent with form data
- save the gclid url parameter as a cookie
- populate gclid_field form field with cookie value

*/

import $ from 'jquery';


$(window).on('load', function () {

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires =" + date.toGMTString();
    document.cookie = name + "=" + value + expires + "; path = /";
  }
  function readCookie(name) {
    var n = name + "=";
    var cookie = document.cookie.split(";");
    for (var i = 0; i < cookie.length; i++) {
      var c = cookie[i];
      while (c.charAt(0) ==" ") { c = c.substring(1, c.length); }
      if (c.indexOf(n) == 0) { return c.substring(n.length, c.length); }
    }
    return null;
  }
  function getParam(p) {
    var params = new URLSearchParams(document.location.search);
    var gclid = params.get(p);
    return gclid
  }
  var gclid = getParam("gclid");
  if (gclid) {
    var gclsrc = getParam("gclsrc");
    if (!gclsrc || gclsrc.indexOf("aw") !== -1) {
      setCookie("gclid", gclid, 90);
    }
  }

  if ($('.gclid_field').length) {
    $('.gclid_field input').val(readCookie("gclid")); 
  }


});
